import { put, call, takeLatest } from 'redux-saga/effects';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import * as policyService from '../../services/policyService';

function* getPolicyDetails(options) {
  try {
    const { dateOfLoss } = options.payload;
    const response = yield call(policyService.getPolicyDetails, dateOfLoss);

    const policyDetails = response.data?.data?.getPolicyDetails?.policies;
    if (policyDetails) {
      window.sessionStorage.setItem('policyDetails', JSON.stringify(policyDetails));
    }
    window.dispatchEvent(new StorageEvent('storage', { key: 'policyDetails', newValue: JSON.stringify(policyDetails) }));

    if (response.data.errors) {
      yield put(actions.setPolicyDetailsError(response.data.errors));
    } else {
      yield put(actions.setPolicyDetails(response.data.data.getPolicyDetails));
    }
  } catch (error) {
    yield put(actions.setPolicyDetailsError(error));
  } finally {
    options.payload.onComplete();
  }
}

export default function* saga() {
  yield takeLatest(actionTypes.GET_POLICY_DETAILS, getPolicyDetails);
}
